import { Link, useNavigate } from "react-router-dom";
import BookingType from "../../../api/enums/BookingType";
import Gender from "../../../api/enums/Gender";
import { HostChatMessage, PartyModel } from "../../../types";
import { iconsImgs } from "../../../utils/icons";
import { routes } from "../../../routes/routes";
import { getUserAvatar } from "../../../utils/getMedia";
import { useContext } from "react";
import { SelectedGroupContext } from "../../../GlobalContext/groupDetailContext";
import { formateDateForPromoterGroups } from "../../../utils/datePareser";
import GetHostChatMessages from "../../../api/GetHostChatMessagesApi";
import { formatChatMessageForDisplay } from "../../../utils/chatMessageText";
import AuthClient from "../../../api/AuthClient";
import GetOfferSetting from "../../Offers/GetOfferSetting";
import { OfferSettings } from "../../../api/enums/OfferTypes";
import handleImgError from "../../../handleImgError";

interface Props {
    group: PartyModel;
}

const ACCEPTED_CHAT_PREVIEW_MAX_LENGTH = 80;

const truncatePreviewText = (value: string, maxLength: number): string => {
    if (value.length <= maxLength) {
        return value;
    }

    return `${value.slice(0, maxLength).trimEnd()}...`;
};

const AcceptedGroupDetail: React.FC<Props> = ({ group }) => {

    const authClient = new AuthClient();
    const navigate = useNavigate();

    const { setSelectedGroup } = useContext(SelectedGroupContext);
    const handleClickInvitation = (selectedGroup: PartyModel) => {
        if (selectedGroup) {
            setSelectedGroup(selectedGroup);
        }
    };

    const openGroupDetail = () => {
        handleClickInvitation(group);
        navigate(routes.PromGroupDetailPage(group.party.city, group.party.id));
    };

    const selectedPromoterOffer = group.promotersOffers.find((promoterOffer) =>
        promoterOffer.offers.some((offer) => offer.isAccepted === true)
    );
    const acceptedOffer = selectedPromoterOffer?.offers.find(
        (offer) => offer.isAccepted === true
    );
    const acceptedOfferOptions = acceptedOffer?.options?.filter((option) =>
        Object.values(OfferSettings).includes(option as OfferSettings)
    ) ?? [];

    const openChats = (partyGroup: PartyModel) => {

        const selectedPromoterOffer = partyGroup.promotersOffers.find((promoterOffer) =>
            promoterOffer.offers.some((offer) => offer.isAccepted === true)
        );
        const acceptedOffer = selectedPromoterOffer?.offers.find(
            (offer) => offer.isAccepted === true
        );
        const groupAdminInvitation = partyGroup.invitations.find((invitation) => invitation.isGroupAdmin) ?? partyGroup.invitations[0];

        const hostChatMessages = new GetHostChatMessages(authClient);

        if (acceptedOffer?.id) hostChatMessages.getChatMessages(acceptedOffer.id).then((response) => {

            if (response.data) {
                const messages: HostChatMessage[] | undefined = response.data;

                if (Object.keys(acceptedOffer).length > 0) {

                    acceptedOffer.partyDate = partyGroup.party.partyDate;
                }
                navigate(routes.ChatPages, {
                    state: {
                        messages: messages,
                        offer: acceptedOffer,
                        groupAdminName: `${groupAdminInvitation?.firstName ?? ""} ${groupAdminInvitation?.lastName ?? ""}`.trim(),
                        groupAdminId: groupAdminInvitation?.id,
                        promoterName: selectedPromoterOffer?.promoter.FirstName,
                        promoterId: selectedPromoterOffer?.promoter.id,
                        currentUserId: selectedPromoterOffer?.promoter.id,
                        returnTo: `${routes.PromotersMode}?tab=accepted`,
                    }
                });
            }
        });
    }
    return (
        <>
            <div
                className="groupPromoter mb-3"
                role="button"
                tabIndex={0}
                onClick={openGroupDetail}
                onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        openGroupDetail();
                    }
                }}
            >
                <div className="desktopUI">

                    {/*Date of the Accepted group and ClubName*/}
                    <div className="datePm  d-flex align-items-center w-100">
                        <p> {formateDateForPromoterGroups(group.party.partyDate)} </p>
                        <p className="ms-5 fw-300">
                            {acceptedOffer?.clubName}
                        </p>
                    </div>

                    {/* Column Section */}
                    <div className="text-center row accepted-summary-row">
                        <div className="greyBorder accepted-summary-cell accepted-summary-cell--guests col-4">
                            <div>
                                <p className="m-0">{group.invitations[0]?.firstName}</p>
                            </div>

                            <div className="d-flex justify-content-center">
                                <p className="m-0 yellowTxt">
                                    {
                                        group.invitations.filter(
                                            (invitation) =>
                                                Gender[invitation.gender].toString() ===
                                                Gender.Female.toString()
                                        ).length
                                    }
                                </p>
                                <img
                                    src={iconsImgs.Female}
                                    alt="female icon"
                                    className=" Icons"
                                />
                                <p className="yellowTxt m-0">
                                    {
                                        group.invitations.filter(
                                            (invitation) =>
                                                Gender[invitation.gender].toString() ===
                                                Gender.Male.toString()
                                        ).length
                                    }
                                </p>
                                <img src={iconsImgs.Male} alt="male icon" className=" Icons" />
                            </div>
                        </div>

                        <div className="greyBorder accepted-summary-cell accepted-summary-cell--booking col-3">
                            {(() => {
                                switch (group.party.bookingType.toString()) {
                                    case BookingType[BookingType.GuestList]:
                                        return (
                                            <p className="guestList">Guest List</p>
                                        );

                                    case BookingType[BookingType.TableBooking]:
                                        return (
                                            <>
                                                <p className="m-0">Table</p>
                                                {acceptedOffer?.minSpend
                                                    && acceptedOffer?.minSpend > 0
                                                    && <>
                                                        <p className="m-0 yellowTxt">{acceptedOffer.currencySymbol}{acceptedOffer.minSpend}</p>
                                                    </>}

                                            </>
                                        );
                                }
                            })()
                            }
                        </div>

                        <div className="greyBorder accepted-summary-cell accepted-offer-options col-5">
                            {acceptedOfferOptions.map((option) => (
                                <div key={option} className="accepted-offer-options__item">
                                    <GetOfferSetting option={option} isIcon />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Guest Pictures Section */}
                    <div className="promoter-avatar-row">
                        {group.invitations.map((invitation) => (
                            <Link to={routes.PromGroupPhotosPage(group.party.city, group.party.id)}
                                key={invitation.id}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleClickInvitation(group);
                                }}
                                className="promoter-avatar-row__link"
                            >
                                <img
                                    src={getUserAvatar(invitation?.id!)}
                                    alt="Profile Image"
                                    className="imgGuestA promoter-avatar-row__image"
                                    onError={(event) =>
                                        handleImgError(
                                            event,
                                            typeof invitation.gender === "string"
                                                ? invitation.gender
                                                : Gender[invitation.gender]
                                        )
                                    }
                                />
                            </Link>
                        ))}
                    </div>

                    <div className="chatPreview m-1 row align-items-center">
                        {/* Clubbable Messages Preview */}
                        <div className="col-8 mt-2">
                            <div className="yellowTxt text-start ms-2">
                                {group.hostChatMessages.slice(-3).map((message, index) => {
                                    const displayMessage = `${message.senderName}: ${formatChatMessageForDisplay(message.message)}`;
                                    const truncatedMessage = truncatePreviewText(displayMessage, ACCEPTED_CHAT_PREVIEW_MAX_LENGTH);

                                    return (
                                        <p
                                            key={index}
                                            className="yellowTxt mb-0 acceptedChatPreviewMessage"
                                            title={displayMessage}
                                        >
                                            {truncatedMessage}
                                        </p>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Open Chat Button */}
                        <div className="col-4 d-flex justify-content-end">
                            <button
                                className="chatButton"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    openChats(group);
                                }}
                            >
                                Open Chat
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AcceptedGroupDetail;
